import { globalEvents } from "src/constants/globalEvents";

/**
 * Registers a handler that drops everything scoped to the user whose session is
 * ending.
 *
 * Logging out (`USER_CLEAR`) and authenticating as a different user
 * (`USER_CHANGED` — including the anonymous funnel account giving way to a real
 * login) invalidate user-scoped state identically, so anything holding user data
 * must react to both. Subscribing to only `USER_CLEAR` is how one user's cached
 * subscriptions, answers or flags end up deciding things for the next one.
 *
 * Both events are dispatched before the next user's data starts loading, so a
 * handler may also drop in-flight request de-duplication: a promise started for
 * the previous user must never be awaited by the next one.
 *
 * @returns a function that unregisters the handler again.
 */
export const onUserSessionReset = (handler: () => void): (() => void) => {
  window.addEventListener(globalEvents.USER_CLEAR, handler);
  window.addEventListener(globalEvents.USER_CHANGED, handler);

  return () => {
    window.removeEventListener(globalEvents.USER_CLEAR, handler);
    window.removeEventListener(globalEvents.USER_CHANGED, handler);
  };
};
